<template>
    <div>
        <v-row v-for="(field, index) in panelFields" :key="index">
            <v-col
                v-if="field.showFieldTitle && field.isVisible"
                cols="5"
                class="sidebar-title caption pb-1"
                :class="field_title_padding(field)"
            >
                {{ field.field.title }}
            </v-col>
            <v-col
                v-if="field.isVisible"
                :cols="field.showFieldTitle ? 7 : 12"
                class="pb-1 pt-0"
            >
                <!-- :client param is used in ClientEmailsList and ClientContactsList -->
                <component
                    :is="field.component"
                    :client="relatedObject"
                    :relatedObject="relatedObject"
                    :relatedType="relatedType"
                    :sub-type="subType"
                    :group-key="groupKey"
                    :field="field"
                    @viewAllNotes="$emit('viewAllNotes')"
                    @softPanelStateChange="$emit('softPanelStateChange', $event)"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>

export default {
    name: "SidebarPanelContent",
    props: {
        panelFields: {
            type: Array,
            required: true,
        },
        relatedObject: {
            type: Object,
            required: true,
        },
        relatedType: {
            type: String,
            required: true,
        },
        subType: {
            type: String,
            default: null,
        },
        groupKey: {
            type: String,
            default: "",
        },
    },
    setup() {
        const field_title_padding = (panelField) => {
            // Avatar icon size affects the row height and requires some additional padding for title
            const field_type_with_extra_padding = ["client", "user_single", "user_multi"]
            return field_type_with_extra_padding.includes(panelField.field.type) ? "pt-2" : "pt-1"
        }

        return {
            field_title_padding
        }
    }
}

</script>

<style scoped lang="scss">
.sidebar-title {
    color: var(--v-g4-base);
}

</style>